import React from "react";


export function MarkDraft() {
  return <span className="draft color-lightyellow">In dev</span>
}

export default MarkDraft;
